module.exports = __webpack_public_path__ + "static/img/A12.c5cac61c.jpg";